<script setup lang="ts">
import { useToast } from '~/composables/useToast'
const { toasts, remove } = useToast()
</script>

<template>
  <div class="fixed bottom-6 right-6 z-[100] flex flex-col gap-3">
    <TransitionGroup name="toast">
      <div 
        v-for="toast in toasts" 
        :key="toast.id"
        class="bg-white text-gray-900 border border-gray-200 shadow-lg rounded-lg px-4 py-3 flex items-center gap-3 min-w-[300px] max-w-sm animate-slide-up"
      >
        <div v-if="toast.type === 'success'" class="bg-black text-white rounded-full p-0.5 w-5 h-5 flex items-center justify-center shrink-0">
          <Icon name="heroicons:check" class="w-3 h-3" />
        </div>
        <div v-else-if="toast.type === 'error'" class="bg-red-500 text-white rounded-full p-0.5 w-5 h-5 flex items-center justify-center shrink-0">
          <Icon name="heroicons:x-mark" class="w-3 h-3" />
        </div>

        <p class="text-sm font-medium whitespace-pre-line">{{ toast.message }}</p>

        <button @click="remove(toast.id)" class="ml-auto text-gray-400 hover:text-gray-600">
           <Icon name="heroicons:x-mark" class="w-4 h-4" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateY(20px);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>